module.exports = __webpack_public_path__ + "static/step_3_2-content-5841de32c696076c1bf46ae5706a9e98.png";